import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
import OrganizationMemberChip from '@/modules/Organizations/components/info/OrganizationMemberChip.vue'
import { mdiChevronDown, mdiChevronUp } from '@mdi/js'
import { Organization, OrganizationUser, SearchParams } from '@/modules/Organizations/types'
import { fetchLeaderboard } from '@/enitites/organization/api/endpoints'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationMembers',
  props: {
    org: null
  },
  setup(__props: any) {

const props = __props as {
  org: Organization
};



const members = ref<OrganizationUser[]>([])
const sortDirection = ref(true)
// todo: temporal solution, need to remove after BE will be ready
const isRankingDisabled = !('rankingDisabled' in props.org) || props.org.rankingDisabled

const searchParams = ref<SearchParams>({
  pageNumber: 0,
  pageSize: 100,
  sortBy: isRankingDisabled ? 'name' : 'rank',
  sortDir: 'asc',
  orgId: props.org.id,
  year: new Date().getFullYear(),
})

const toggleSortDirection = () => {
  sortDirection.value = !sortDirection.value
  searchParams.value.sortDir = sortDirection.value ? 'asc' : 'desc'
}

const seasons = computed(() => {
  const startYear = 2021
  const currentYear = new Date().getFullYear()
  const years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i)
  return [...years.map((year) => ({ value: year, title: year })), { value: 0, title: 'All Years' }]
})

const loadMembers = async () => {
  const data = await fetchLeaderboard(searchParams.value)
  if (data) {
    members.value = data
  }
}

watch(searchParams, loadMembers, { deep: true })

onMounted(() => {
  loadMembers()
})

return { __sfc: true,props, members, sortDirection, isRankingDisabled, searchParams, toggleSortDirection, seasons, loadMembers, OrganizationMemberChip, mdiChevronDown, mdiChevronUp }
}

})